function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.33137 0.223775L7.77811 0.682364C7.91763 0.82669 7.99449 1.01871 7.99449 1.22393C7.99449 1.42904 7.91763 1.62128 7.77811 1.76561L2.71692 6.99687L7.78373 12.2342C7.92325 12.3783 8 12.5705 8 12.7756C8 12.9807 7.92325 13.1731 7.78373 13.3173L7.33974 13.776C7.05101 14.0747 6.5807 14.0747 6.29198 13.776L0.237633 7.54037C0.0982246 7.39627 -2.4676e-09 7.20425 0 6.99733L0 6.99494C2.47634e-09 6.78971 0.0983348 6.5977 0.237633 6.4536L6.27557 0.223775C6.41498 0.0794482 6.60636 0.000227642 6.80479 0C7.00333 2.36758e-09 7.19207 0.0794482 7.33137 0.223775Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 6.5C2 6.22386 2.22386 6 2.5 6H17.5C17.7761 6 18 6.22386 18 6.5V7.5C18 7.77614 17.7761 8 17.5 8H2.5C2.22386 8 2 7.77614 2 7.5V6.5Z",
  fill: "white"
});

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.a928d7c9.svg";
export { ForwardRef as ReactComponent };